import { inject, Injectable, signal } from '@angular/core';
import { Router, ViewTransitionInfo } from '@angular/router';

export function onViewTransitionCreated(info: ViewTransitionInfo): void {
  const viewTransitionService = inject(ViewTransitionService);
  const router = inject(Router);
  const navigation = router?.currentNavigation();
  const transitionId = navigation?.extras?.state?.transitionId;
  viewTransitionService?.currentTransition.set({...info, transitionId});
  info?.transition?.finished?.finally(() => {
    viewTransitionService?.currentTransition.set(null);
  });
}

@Injectable({
  providedIn: 'root',
})
export class ViewTransitionService {

  public currentTransition = signal<ViewTransitionInfo & {transitionId: string} | null>(null);

  public generateTransitionId(length: number = 10): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

}
